import React from "react";
import Dashboardcardlayout from "../../Components/Layout/Layout";
import myAssessmentIcon from "../../../images/my Assessment.png";
import "./my-assessments.css";
import Rendermyassessmenttable from "./my-assessment-table";
import Responsivemyassessmenttable from "./Responsive/Assessment-table";
import ResponsiveDashboardcardlayout from "../../Components/Layout/ResponsiveLayout";

const Myassessments = (props) => {
  const calcWidth = window.innerWidth;

  return (
    <div className="my-assessment-table">
      {calcWidth <= 767?
        
        <ResponsiveDashboardcardlayout
        headerIcon={myAssessmentIcon}
        headerText="My Assessments"
        bgStyle="assesment"
        >
        {calcWidth <= 767 ? (
          <Responsivemyassessmenttable
            isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
            handleAssessmentPopOver={props.handleAssessmentPopOver}
            handleClosePopOver={props.handleClosePopOver}
            userAssessmentDetails={props.userAssessmentDetails}
            collapseID={props.collapseID}
            toggleCollapse={props.toggleCollapse}
          />
        ) : (
          <div>
            {props.overlayIsVisible && <div className="overlay"></div>}
            <div
              className={
                props.userAssessmentDetails.length == 0 ? "" : "wrap-table"
              }
            >
              <Rendermyassessmenttable
                isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
                handleAssessmentPopOver={props.handleAssessmentPopOver}
                handleClosePopOver={props.handleClosePopOver}
                userAssessmentDetails={props.userAssessmentDetails}
                handleMouseEnter={props.handleMouseEnter}
                reportNotification={props.reportNotification}
                handleModalClose={props.handleModalClose}
              />
            </div>
          </div>
        )}
        </ResponsiveDashboardcardlayout>
        :
        
        <Dashboardcardlayout
        headerIcon={myAssessmentIcon}
        headerText="My Assessments"
      >
        {calcWidth <= 767 ? (
          <Responsivemyassessmenttable
            isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
            handleAssessmentPopOver={props.handleAssessmentPopOver}
            handleClosePopOver={props.handleClosePopOver}
            userAssessmentDetails={props.userAssessmentDetails}
            collapseID={props.collapseID}
            toggleCollapse={props.toggleCollapse}
          />
        ) : (
          <div>
            {props.overlayIsVisible && <div className="overlay"></div>}
            <div
              className={
                props.userAssessmentDetails.length == 0 ? "" : "wrap-table"
              }
            >
              <Rendermyassessmenttable
                isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
                handleAssessmentPopOver={props.handleAssessmentPopOver}
                handleClosePopOver={props.handleClosePopOver}
                userAssessmentDetails={props.userAssessmentDetails}
                handleMouseEnter={props.handleMouseEnter}
                reportNotification={props.reportNotification}
                handleModalClose={props.handleModalClose}
                loading={props.loading}
              />
            </div>
          </div>
        )}
      </Dashboardcardlayout>}
    </div>
  );
};

export default Myassessments;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-assessments/my-assessment.jsx